import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { PROGRESS_BAR_CONSTANTS } from '@outlaw/core';

@Component({
  selector: 'ol-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  progress = input<number>(0);
  height = input<string>('3px');
  color = input<string>();
  backgroundColor = input<string>();
  showShimmer = input<boolean>(true);
  borderRadius = input<string>('2px');

  progressStyles = computed(() => {
    return this.getProgressStyles(this.height(), this.borderRadius());
  });

  containerStyles = computed(() => {
    return this.getContainerStyles(this.height(), this.borderRadius());
  });

  private getProgressStyles(height: string, borderRadius: string): Record<string, string> {
    const styles: Record<string, string> = {
      width: `${Math.max(
        PROGRESS_BAR_CONSTANTS.MIN_PROGRESS,
        Math.min(PROGRESS_BAR_CONSTANTS.MAX_PROGRESS, this.progress())
      )}%`,
      height: height,
      'border-radius': borderRadius,
    };

    if (this.color()) {
      styles['background-color'] = this.color()!;
    }

    return styles;
  }

  private getContainerStyles(height: string, borderRadius: string): Record<string, string> {
    const styles: Record<string, string> = {
      height: height,
      'border-radius': borderRadius,
    };

    if (this.backgroundColor()) {
      styles['background-color'] = this.backgroundColor()!;
    }

    return styles;
  }
}
